<template>
    <div class="w-[100vw] h-[100vh] fixed top-0 left-0 flex justify-center items-center bg-[#0000005a]">
      <div class="w-[40vw]  gap-4 p-4 bg-[#5D5D98] rounded-[10px] flex flex-col">
        <div class="w-full flex gap-2 justify-between items-center">
          <h3 class="text-[#ff9b05]">Filtro Viatura</h3>
          <AppButton class="text-white" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl"
            emitType="close" @close="close" :width="23" :height="23" />
        </div>
  
        <!-- Marca / Modelo -->
        <div class="flex gap-4">
          <div class="flex gap-2 items-center w-1/2">
            <label>Marca:</label>
            <input v-model="marca" type="text" class="text-black border border-[#ccc] p-1 rounded-[5px] w-full">
          </div>
          <div class="flex gap-2 items-center w-1/2">
            <label>Modelo:</label>
            <input v-model="modelo" type="text" class="text-black border border-[#ccc] p-1 rounded-[5px] w-full">
          </div>
        </div>
  
        <!-- Matrícula / Cor -->
        <div class="flex gap-4">
          <div class="flex gap-2 items-center w-1/2">
            <label>Matrícula:</label>
            <input v-model="matricula" type="text" class="text-black border border-[#ccc] p-1 rounded-[5px] w-full">
          </div>
          <div class="flex gap-2 items-center w-1/2">
            <label>Cor:</label>
            <input v-model="cor" type="text" class="text-black border border-[#ccc] p-1 rounded-[5px] w-full">
          </div>
        </div>
  
        <!-- Tipo Viatura -->
        <div class="flex gap-2 items-center">
          <label class="min-w-[6.5rem]">Tipo Viatura:</label>
          <input :disabled="true" v-model="tpViatura_concat" type="text" class="border border-[#ccc] p-1 rounded-[5px] w-full">
          <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="openDialog('tpviatura')"></button>
          <button :style="{ color: 'red' }" @click="remove('tpViatura')">
            <i class="fa-regular fa-circle-xmark text-2xl"></i>
          </button>
        </div>
  
        <!-- Armazém -->
        <div class="flex gap-2 items-center">
          <label class="min-w-[6.5rem]">Armazém:</label>
          <input :disabled="true" v-model="armazem_concat" type="text" class=" border border-[#ccc] p-1 rounded-[5px] w-full">
          <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="openDialog('armazem')"></button>
          <button :style="{ color: 'red' }" @click="remove('armazem')">
            <i class="fa-regular fa-circle-xmark text-2xl"></i>
          </button>
        </div>
  
        <!-- Utilizador -->
        <div class="flex gap-2 items-center">
          <label class="min-w-[6.5rem]">Utilizador:</label>
          <input :disabled="true" v-model="utilizador_concat" type="text" class=" border border-[#ccc] p-1 rounded-[5px] w-full">
          <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="openDialog('utilizador')"></button>
          <button :style="{ color: 'red' }" @click="remove('utilizador')">
            <i class="fa-regular fa-circle-xmark text-2xl"></i>
          </button>
        </div>
  
        <!-- Status / Possui Utilizador -->
        <div class="flex gap-4">
          <div class="flex gap-2 items-center w-1/2">
            <label>Status:</label>
            <select v-model="status" class="text-black p-1 border border-[#ccc] rounded-[5px] w-full">
              <option :value="''"> </option>
              <option value="ativo">Ativo</option>
              <option value="desativado">Desativado</option>
            </select>
          </div>
          <div class="flex gap-2 items-center w-1/2">
            <label>Utilizador:</label>
            <select v-model="possui_utilizador" class="text-black p-1 border border-[#ccc] rounded-[5px] w-full">
              <option :value="''"> </option>
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>
        </div>
  
        <!-- Possui Armazém / Oficina -->
        <div class="flex gap-4">
          <div class="flex gap-2 items-center w-1/2">
            <label>Armazém:</label>
            <select v-model="possui_armazem" class="text-black p-1 border border-[#ccc] rounded-[5px] w-full">
              <option :value="''"> </option>
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>
          <div class="flex gap-2 items-center w-1/2">
            <label>Oficina:</label>
            <select v-model="em_oficina" class="text-black p-1 border border-[#ccc] rounded-[5px] w-full">
              <option :value="''"> </option>
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>
        </div>
  
        <!-- Manutenção / Dano -->
        <div class="flex gap-4">
          <div class="flex gap-2 items-center w-1/2">
            <label>Manutenção:</label>
            <select v-model="em_manutencao" class="text-black p-1 border border-[#ccc] rounded-[5px] w-full">
              <option :value="''"> </option>
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>
          <div class="flex gap-2 items-center w-1/2">
            <label>Dano:</label>
            <select v-model="possui_dano" class="text-black p-1 border border-[#ccc] rounded-[5px] w-full">
              <option :value="''"> </option>
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>
        </div>
  
        <!-- Possui GPS -->
        <div class="flex gap-2 items-center">
          <label class="min-w-[6.5rem]">GPS:</label>
          <select v-model="possui_gps" class="text-black p-1 border border-[#ccc] rounded-[5px] w-full">
            <option :value="''"> </option>
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>

        <!-- Km -->
      <div class="flex gap-4">
        <div class="flex gap-2 items-center w-1/2">
          <label>Km Maior Que:</label>
          <input v-model="km_maior_que" type="number" class="text-black border border-[#ccc] p-1 rounded-[5px] w-full">
        </div>
        <div class="flex gap-2 items-center w-1/2">
          <label>Km Menor Que:</label>
          <input v-model="km_menor_que" type="number" class="text-black border border-[#ccc] p-1 rounded-[5px] w-full">
        </div>
      </div>
  
        <!-- Botões -->
        <div class="flex gap-4 mt-4">
          <AppButton :padding="'var(--padding_btn)'" class="capitalize mb-auto" v-bind:visibility="true" :font_size="12"
            color="#ff9b05" left_icon="fa-solid fa-filter" text="Confirmar" emitType="select" @select="saveFilter" />
          <AppButton :padding="'var(--padding_btn)'" class="capitalize mb-auto" v-bind:visibility="true" :font_size="12"
            color="red" left_icon="fa-regular fa-circle-xmark" text="Cancelar" emitType="select" @select="close" />
        </div>
      </div>
  
      <Dialog v-if="showDialog" :propsData="dialogProps" @close="closeDialog" @returnData="handleReturnData"
        :pagination="true" :multiSelectOptions="{ enabled: true, show_btn: false }" />
    </div>
  </template>
  
  <script>
import AppButton from '@/components/updated/button.vue'
import Dialog from '@/components/dialog/dinamicDialog.vue'

export default {
  components: { AppButton, Dialog },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      marca: '', modelo: '', matricula: '', cor: '', status: null,
      tpViatura: [], tpViatura_concat: '',
      armazem: [], armazem_concat: '',
      utilizador: [], utilizador_concat: '',
      possui_utilizador: null, possui_armazem: null,
      em_oficina: null, em_manutencao: null,
      possui_dano: null, possui_gps: null,
      showDialog: false,
      dialogProps: { entity: [''], title: '', sideBar: true },
      currentType: ''
    }
  },
  created() {
    if (this.data) this.preencherCampos(this.data)
  },
  watch: {
    data: {
      handler(val) {
        if (val) this.preencherCampos(val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    preencherCampos(val) {
      this.marca = val.marca || ''
      this.modelo = val.modelo || ''
      this.matricula = val.matricula || ''
      this.cor = val.cor || ''
      this.status = val.status || null

      this.tpViatura = val.tpViatura || []
      this.tpViatura_concat = this.tpViatura.map(d => d.nome).join(', ')

      this.armazem = val.armazem || []
      this.armazem_concat = this.armazem.map(d => d.nome).join(', ')

      this.utilizador = val.utilizador || []
      this.utilizador_concat = this.utilizador.map(d => d.user || d.nome).join(', ')

      this.possui_utilizador = val.possui_utilizador ?? null
      this.possui_armazem = val.possui_armazem ?? null
      this.em_oficina = val.em_oficina ?? null
      this.em_manutencao = val.em_manutencao ?? null
      this.possui_dano = val.possui_dano ?? null
      this.possui_gps = val.possui_gps ?? null
    },
    close() { this.$emit('close') },
    saveFilter() {
      const data = {
        marca: this.marca,
        modelo: this.modelo,
        matricula: this.matricula,
        cor: this.cor,
        status: this.status,
        tpViatura: this.tpViatura,
        armazem: this.armazem,
        utilizador: this.utilizador,
        possui_utilizador: this.possui_utilizador,
        possui_armazem: this.possui_armazem,
        em_oficina: this.em_oficina,
        em_manutencao: this.em_manutencao,
        possui_dano: this.possui_dano,
        possui_gps: this.possui_gps
      }
      this.$emit('save', data)
    },
    openDialog(key) {
      if (key === 'tpviatura') {
        this.dialogProps.entity[0] = 'tpviatura'
        this.currentType = 'tpViatura'
      } else if (key === 'armazem') {
        this.dialogProps.entity[0] = 'armazem'
        this.currentType = 'armazem'
      } else if (key === 'utilizador') {
        this.dialogProps.entity[0] = 'utilizador'
        this.currentType = 'utilizador'
      }
      this.showDialog = true
    },
    handleReturnData(data) {
      if (this.currentType === 'tpViatura') {
        this.tpViatura = Array.isArray(data.tpviatura) ? data.tpviatura : [data.tpviatura]
        this.tpViatura_concat = this.tpViatura.map(d => d.nome).join(', ')
      } else if (this.currentType === 'armazem') {
        this.armazem = Array.isArray(data.armazem) ? data.armazem : [data.armazem]
        this.armazem_concat = this.armazem.map(d => d.nome).join(', ')
      } else if (this.currentType === 'utilizador') {
        this.utilizador = Array.isArray(data.utilizador) ? data.utilizador : [data.utilizador]
        this.utilizador_concat = this.utilizador.map(d => d.user || d.nome).join(', ')
      }
    },
    closeDialog() { this.showDialog = false },
    remove(key) {
      if (key === 'tpViatura') {
        this.tpViatura = []
        this.tpViatura_concat = ''
      } else if (key === 'armazem') {
        this.armazem = []
        this.armazem_concat = ''
      } else if (key === 'utilizador') {
        this.utilizador = []
        this.utilizador_concat = ''
      }
    }
  }
}
</script>

  
  <style scoped>
  .red-border { border: 1px solid white; background-color: rgba(176, 88, 88, 0.664) }
  </style>
  